// extracted by mini-css-extract-plugin
export var standaloneTable = "_h7-0";
export var standaloneTableWithBodyFill = "_h7-1";
export var withExtraHeader = "_h7-2";